import React, { useEffect, useState, useRef } from 'react'
import style from './index.module.scss'
import axios from 'axios'
import { message, Drawer, Popconfirm, Button } from 'antd';
import defaultAvatar from './defaultAvatar.png'
// import { userModule } from '../../modules/user';
import { SocketModule } from '../../modules/socket'
import { StorageModule } from '../../modules/storage';
import { DoubleLeftOutlined, ClearOutlined, MailOutlined } from '@ant-design/icons';
import * as apis from '../../api/chat';
import './index.css';
import { getImgUrlById } from '../../util';
import { async } from '@antv/x6/lib/registry/marker/async';
import useStore from '../../store/useStore'

interface Props {
    visible: boolean;
    title?: any;
    survey?: any;
    onClose: () => void;
    fromShare?: boolean;
}

interface State {
    userInfo: any;
    server: any;
    token: string;
    formId: string;
    chatUserId: string;
    chatList: any[];
    total: number;
    current: number;
    size: number;
}

const Msg = (props: Props) => {
    const [msgList, setMsgList] = useState<any[]>([]);
    const [chatMsgList, setChatMsgList] = useState<any[]>([]);
    const [chatMsgTotal, setChatMsgTotal] = useState<any[]>([]);
    const [chatUserList, setChatUserList] = useState<any[]>([]);
    const [sysExp, setSysExp] = useState<boolean>(false);
    const [chatExp, setChatExp] = useState<boolean>(false);
    const [colExpKey, setColExpKey] = useState<any[]>([]);
    const [state, setState] = useState<State>({
        userInfo: {},
        server: null,
        token: '',
        formId: '',
        chatUserId: '',
        chatList: [{}, {}, {}, {}, {}, {}],
        total: 0,
        current: 1,
        size: 10
    });
    const [content, setContent] = useState<string>('');
    // const [initStatus, setInitStatus] = useState<boolean>(false);
    const [sendLoading, setSendLoading] = useState<boolean>(false);
    const [listLoading, setListLoading] = useState<boolean>(false);
    const [ikey, setIkey] = useState<string>('');
    const scroll = useRef<any>()
    const { store, dispatch } = useStore();

    useEffect(() => {
        state.userInfo = StorageModule.getUser().user;
        setState({ ...state })
    }, [msgList, chatMsgList])

    useEffect(() => {
        // if (props.survey && props.survey.id && !initStatus) {
        //     setInitStatus(true)
        //     userLogin()
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (props.fromShare) {
            const url = new URL(window.location.href.replace('/#', ''));
            const ikey = url.searchParams.get('ikey') || '';
            if (ikey) {
                setIkey(ikey);
            }
        }
    }, [])
    useEffect(() => {
        showPanel();
    }, [props.visible])
    const clearAllMsg = async () => {
        try {
            let res = await apis.noticeConfirmAll()
            showPanel()
        } catch {

        }
    }
    const clearMsg = async (item: any) => {
        try {
            let res: any = await apis.noticeConfirm(item.id, { noticeId: item.id })
            if (res.ok) {
                props.onClose()
                var newResponseString = item.content[0].value.replace(/\"log_id\": (\d+)/g, '"topicId":"$1"');
                var resultObj = JSON.parse(newResponseString);
                console.log(window.location.hash)
                if (window.location.hash != '#/view') {
                    window.location.hash = '#/view'
                }
                if (resultObj.topicId != store.subjectInfo.subjectId) {
                    dispatch({
                        type: 'SET_SUBJECTINFO',
                        data: { subjectCatalogue: [], subjectId: resultObj.topicId, data: store.subjectInfo.initData }
                    });
                }
            }
        } catch {

        }
    }
    const showPanel = async () => {
        // const uid = (StorageModule.getUser().user as any).id;
        const param = {
            // user: uid,
            skip: 0,
            limit: 100,
            confirmed: false
        };
        let list: any[] = [];
        const res = await apis.broadcastNotice(param);
        setMsgList(res?.data.list);
        // if(){
        dispatch({
            type: 'SET_BOTTOMBAR_MSG',
            data: res?.data.list.length > 0 ? true : false
        });
        // }
    }

    const render = (
        <Drawer
            title={props.title}
            placement="right"
            width={'480px'}
            onClose={() => {
                props.onClose()
            }}
            closeIcon={null}
            open={props.visible}
            className={'chatinfopop ' + style.draw}>
            <div className={style.title}>
                <div className={style.txt}
                >系统消息</div>
                {msgList?.length !== 0 && <Popconfirm placement="topLeft" title={'确认全部清除消息么？'} onConfirm={() => { clearAllMsg() }} okText="Yes" cancelText="No">

                    <Button disabled={msgList?.length == 0} className={style.clearbtn} type="text">全部清除</Button>

                </Popconfirm>}
            </div>
            <div className={style.list}>
                {msgList.map((i: any, index: any) => (
                    <Popconfirm key={index} placement="topLeft" title={'确认要进入该主题么？'} onConfirm={() => { clearMsg(i) }} okText="Yes" cancelText="No">

                        <div className={style.item} onClick={() => {

                        }}>
                            {
                                !i.confirmed && <div className={style.unread}></div>
                            }
                            <div className={i.confirmed ? style.unread_text : ''}>
                                {JSON.parse(i.content[0].value).type === 'topic_user_data_change' ?
                                    <div>你受邀参加“{JSON.parse(i.content[0].value).topicName}”的讨论！</div> : <div>主题“{JSON.parse(i.content[0].value).topicName}”讨论的内容有变更！</div>}
                            </div>
                        </div>
                    </Popconfirm>
                ))}
            </div>
        </Drawer>
    )

    return props.visible ? render : null
}

export default Msg
